// store.js
import { configureStore } from '@reduxjs/toolkit';
import masterReducer from './slices/masterSlice';
import specialitiesReducer from './slices/specialitiesSlice';
import businessLocationSlice from './slices/businessLocationSlice';
import clientsReducer from './slices/clientsSlice';
import servicesSlice from './slices/servicesSlice';
import appointmentsSlice from './slices/appointmentsSlice';
import businessHoursSlice from './slices/businessHoursSlice';
import dayOffSlice from './slices/dayOffSlice';
import masterBreakSlice from './slices/masterBreakSlice';
import whatsappSlice from './slices/whatsappSlice';
import expensesSlice from './slices/expensesSlice';
import gallerySlice from './slices/gallerySlice';
import profileImageSlice from './slices/profileImageSlice';
import sendSms from './slices/sendSms';
import smsMessagesSlice from './slices/smsMessagesSlice';
import fetchReviews from './slices/fetchReviews';
import WaitlistSlice from './slices/WaitlistSlice';
import userSlice from './slices/userSlice';
import userPhotoSlice from './slices/userPhotoSlice';
import pushTokensSlice from './slices/pushTokensSlice';
import surveyQuestionSlice from './slices/surveyQuestionSlice';
import calendarSettingsSlice from './slices/calendarSettingsSlice';
import sitemapReducer from "./slices/sitemapSlice";
import masterCertificatesSlice from "./slices/masterCertificatesSlice";
import contactUsSlice from "./slices/contactUsSlice";
import masterLogoSlice from "./slices/masterLogoSlice";
import masterSession from "./slices/masterSessionSlice";
import userSession from "./slices/userSessionSlice";
import clientPhotos from './slices/clientPhotosSlice';
import googleCalendarReducer from './slices/googleCalendarSlice';
import inventorySlice from './slices/inventorySlice';
import allpaySlice from './slices/allpaySlice';
import masterWebPageSettings from './slices/masterWebPageSettingsSlice';
import takbullReducer from './slices/takbullCreateSlice';
import anamnesisSlice from './slices/anamnesisSlice';
import messageCounter from './slices/messageCounterSlice';
import qrcodeReducer from './slices/qrcodeSlice';
import salonMastersReducer from './slices/salonMastersSlice';
import ordersReducer from './slices/ordersSlice';
import promo from './slices/promoSlice';
import clientVisitsReducer from "./slices/clientVisitsSlice";
import clientPackagesReducer from "./slices/clientPackagesSlice";
import holidaysReducer from "./slices/holidaysSlice";
import favoritesReducer from "./slices/favoritesSlice";
import surveyLinksReducer from './slices/surveyLinksSlice';
import publicRecurringBreakReducer from './slices/publicRecurringBreakSlice';
import reviewRequestsReducer from './slices/reviewRequestsSlice';
import notesReducer from './slices/notesSlice';
import servicePackagesReducer from './slices/servicePackagesSlice';
import surveySetsReducer from './slices/surveySetsSlice';
import clientGroupsReducer from './slices/clientGroupsSlice';
import messageTemplatesReducer from './slices/messageTemplatesSlice';
import takbullPaymentGatewayReducer from './slices/takbullPaymentGatewaySlice';
import giftCertificatesReducer from './slices/giftCertificatesSlice';
import permissionsReducer from './slices/permissionsSlice';
import recurringBreakReducer from './slices/recurringBreakSlice';
import takbullCreateReducer from "./slices/takbullCreateSlice";
import takbullPaymentsReducer from "./slices/takbullPaymentsSlice";
import takbullSignupReducer from "./slices/takbullSignupSlice";
import easycardConnectReducer from "./slices/easycardConnectSlice";
import easycardPaymentsReducer from "./slices/easycardPaymentsSlice";
import broadcastTemplatesReducer from "./slices/broadcastTemplatesSlice";
import chatReducer from "./slices/chatSlice";
import chatPhotosReducer from "./slices/chatPhotoSlice";
import chatDocumentsReducer from "./slices/uploadChatDocument";
import togglesReducer from "./slices/togglesSlice";
import webPushReducer from "./slices/webPushSlice";
import notificationsReducer from "./slices/notificationsSlice";
import remindersReducer from "./slices/remindersSlice";
import takbullConnectReducer from "./slices/takbullConnect";
import clientSettingsReducer from "./slices/clientSettingsSlice";
import appointmentHistoryReducer from "./slices/appointmentHistorySlice";
import servicePhotosReducer from "./slices/servicePhotosSlice";
import additionalAppointmentRemindersReducer from './slices/additionalAppointmentRemindersSlice';
import reportExportConsentReducer from "./slices/reportExportConsentSlice";
import surveySettingsReducer from "./slices/surveySettingsSlice";
import productUpdates from "./slices/productUpdatesSlice";
import guideFeedback from "./slices/guideFeedbackSlice";
import whatsappConnectReducer from "./slices/whatsappConnectSlice";
import standaloneReceiptsReducer from "./slices/standaloneReceiptsSlice";
import installmentsReducer from "./slices/installmentsSlice";
import aftercareReducer from "./slices/aftercareSlice";

export const store = configureStore({
  reducer: {
    master: masterReducer,
    specialities: specialitiesReducer,
    businessLocation: businessLocationSlice,
    clients: clientsReducer,
    services: servicesSlice,
    appointments: appointmentsSlice,
    businessHours: businessHoursSlice,
    dayOff: dayOffSlice,
    masterBreak: masterBreakSlice,
    whatsapp: whatsappSlice,
    expenses: expensesSlice,
    gallery: gallerySlice,
    profileImage: profileImageSlice,
    sentSms: sendSms,
    smsMessages: smsMessagesSlice,
    reviews: fetchReviews,
    waitlist: WaitlistSlice,
    calendarSettings: calendarSettingsSlice,
    users: userSlice,
    photouser: userPhotoSlice,
    pushNotificationToken: pushTokensSlice,
    survey: surveyQuestionSlice,
    sitemap: sitemapReducer,
    certificates: masterCertificatesSlice,
    contactUs: contactUsSlice,
    masterLogo: masterLogoSlice,
    masterSession: masterSession,
    userSession: userSession,
    clientPhotos: clientPhotos,
    googleCalendar: googleCalendarReducer,
    inventory: inventorySlice,
    allpay: allpaySlice,
    masterWebPageSettings: masterWebPageSettings,
    anamnesis: anamnesisSlice,
    messageCounter: messageCounter,
    qrcode: qrcodeReducer,
    salonMasters: salonMastersReducer,
    orders: ordersReducer,
    promo: promo,
    clientVisits: clientVisitsReducer,
    clientPackages: clientPackagesReducer,
    holidays: holidaysReducer,
    favorites: favoritesReducer,
    surveyLinks: surveyLinksReducer,
    publicRecurringBreak: publicRecurringBreakReducer,
    reviewRequests: reviewRequestsReducer,
    notes: notesReducer,
    servicePackages: servicePackagesReducer,
    surveySets: surveySetsReducer,
    clientGroups: clientGroupsReducer,
    messageTemplates: messageTemplatesReducer,
    giftCertificates: giftCertificatesReducer,
    permissions: permissionsReducer,
    recurringBreak: recurringBreakReducer,
    featureToggles: togglesReducer,

    takbullConnect: takbullConnectReducer,
    takbullCreate: takbullCreateReducer,
    takbullPaymentGateway: takbullPaymentGatewayReducer,
    takbullPayments: takbullPaymentsReducer,
    takbullSignup: takbullSignupReducer,

    easycardConnect: easycardConnectReducer,
    easycardPayments: easycardPaymentsReducer,
    broadcastTemplates: broadcastTemplatesReducer,

    chat: chatReducer,
    chatPhotos: chatPhotosReducer,
    chatDocuments: chatDocumentsReducer,

    webPush: webPushReducer,
    notifications: notificationsReducer,

    reminders: remindersReducer,
    clientSettings: clientSettingsReducer,
    appointmentHistory: appointmentHistoryReducer,

    servicePhotos: servicePhotosReducer,
    additionalAppointmentReminders: additionalAppointmentRemindersReducer,
    reportExportConsent: reportExportConsentReducer,

    surveySettings: surveySettingsReducer,

    productUpdates: productUpdates,
    guideFeedback: guideFeedback,

    whatsappConnect: whatsappConnectReducer,

    standaloneReceipts: standaloneReceiptsReducer,
    installments: installmentsReducer,
    aftercare: aftercareReducer,
  },
});

export default store;
